import { BaseService } from '@services/BaseService';
import {
  HostedCheckoutTransactionCreateModel,
  HostedCheckoutTransactionViewModel
} from '@models/HostedCheckoutTransactionViewModel';
import { HostedCheckoutLaunchRequestViewModel } from '@models/HostedCheckoutLaunchRequestViewModel';

class PaymentService extends BaseService {
  constructor() {
    super('');
  }

  create(payment: HostedCheckoutTransactionCreateModel): Promise<HostedCheckoutLaunchRequestViewModel> {
    return this.fetch<HostedCheckoutLaunchRequestViewModel>(`payments/transactions`, {
      method: 'POST',
      body: JSON.stringify(payment)
    });
  }

  cancelTransaction(id: number) {
    return this.fetch<HostedCheckoutTransactionViewModel>(`payments/transactions/${id}`, {
      method: 'DELETE'
    });
  }

  getHostedTransaction(transactionId: number) {
    return this.fetch<HostedCheckoutTransactionViewModel>(`payments/transactions/${transactionId}`, {
      method: 'GET'
    });
  }
}

export const paymentService = new PaymentService();



// WEBPACK FOOTER //
// ./src/_services/PaymentService.ts